// extracted by mini-css-extract-plugin
module.exports = {"lightbox":"image_lightbox__3_tq7","show":"image_show__3QYG8","show_image":"image_show_image__1lbK9"};